import { API, API_GET } from "../../../Config"


export const GetRecipe = () => {
  return (
    API_GET(API.GetRecipe)
  )
}

